export default __webpack_public_path__ + "static/media/search.95c7d252.svg";